import FeedbackPage from '@/components/FeedbackPage'

export default function MemoryGameFeedbackPage() {
  return (
    <FeedbackPage
      emoji="🧠"
      headingKey="pages.onboarding.memoryFeedback.heading"
      descriptionKey="pages.onboarding.memoryFeedback.description"
    />
  )
}
